import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Logo from "assets/svg/logo.svg";

// toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";


import HomePage from "pages/home";
import { ModalProvider } from "context/modal-context";
import ServiceModal from "components/modal/service-modal";

const AboutPage = lazy(() => import("pages/about"));
const CorporateTrainingPage = lazy(() => import("pages/corporate-training"));
const CorporateTrainingDetailPage = lazy(() => import("pages/corporate-training/detail"));
const ScrollToTop = lazy(() => import("helpers/scrollToTop"));

function App() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 60,
      // Disable horizontal slide animations on small screens to prevent overflow
      disable: () => window.innerWidth < 768,
    });
  }, []);

  return (
    <ModalProvider>
      <BrowserRouter>
      <div style={{ overflowX: "hidden", width: "100%" }}>
        <ScrollToTop />
        <ServiceModal />
        <Suspense
          fallback={
            <div className="fixed top-0 left-0 w-full h-screen flex items-center justify-center bg-white z-[100]">
              <img src={Logo} alt="" className="object-contain w-60" />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/corporate-training" element={<CorporateTrainingPage />} />
            <Route path="/corporate-training/:slug" element={<CorporateTrainingDetailPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Suspense>

        <ToastContainer />
      </div>
      </BrowserRouter>
    </ModalProvider>
  );
}

export default App;
